module.exports = __webpack_public_path__ + "static/ill1-f3800aee33e78a8c6467ac05b3c97b11.svg";